import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppSelect from './form/base/app-select';
import { apiService } from '../services/api.service';
import { AppStore } from '../store/store';
import { MerchantState, merchantSliceActions } from '../store/merchant.slice';
import { ReactComponent as MerchantsIcon } from '../assets/icons/merchants.svg';
import { LabelValue } from '../types/label-value.types';

const MerchantSelector = () => {
    const dispatch = useDispatch();
    const { allowedMerchants, selectedMerchantId, loaded } = useSelector<AppStore, MerchantState>((state) => state.merchant);

    useEffect(() => {
        if (loaded) return;
        apiService.getMyAllowedMerchants()
            .then((response) => {
                dispatch(merchantSliceActions.setAllowedMerchants(response.data ?? []));
            })
            .catch((e) => {
                console.error('Failed to load allowed merchants', e);
                dispatch(merchantSliceActions.setAllowedMerchants([]));
            });
    }, [loaded, dispatch]);

    const options = useMemo<LabelValue<string>[]>(() =>
        allowedMerchants
            .filter((m) => !!m.id)
            .map((m) => ({
                label: `${m.lastName ?? ''}`.trim() || m.email || (m.id as string),
                value: m.id as string,
            })),
        [allowedMerchants]
    );

    const handleChange = (value: string) => {
        dispatch(merchantSliceActions.setSelectedMerchantId(value));
    };

    if (!loaded || options.length === 0) {
        return null;
    }

    return (
        <div className='merchant-selector flex-column flex-gap-5'>
            <AppSelect<string>
                theme='filter'
                options={options}
                value={selectedMerchantId}
                onChange={handleChange}
                placeholder='Select merchant'
                icon={<MerchantsIcon width={16} height={16} />}
            />
        </div>
    );
};

export default MerchantSelector;
